import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer, Header } from '@safedns/skydns-ui-react-lib';

import SubMenu from '../components/sub-menu/SubMenu';
import Navbar from '../components/navbar/Navbar';
import { BASE_URL, useGetUserQuery } from '../services/ADapi';
import logo from '../icons/Logo.svg';
// import logo from '../../icons/NY-logo.svg';

const ProtectedRoutes = () => {
  const { data, isLoading } = useGetUserQuery();
  const permissions = data?.permissions;
  const isAuthenticated = data?.is_authenticated;

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      window.location.href = `${BASE_URL}/auth/login/`;
    }
  }, [isAuthenticated, isLoading]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="App">
      <Header
        logoUrl={logo}
        adminUrl={`${BASE_URL}/you-were-never-here/`}
        logoutUrl={`${BASE_URL}/auth/logout/`}
        isStaff={permissions?.is_staff}
        isAuthenticated={isAuthenticated}
      />
      <div className="layout">
        <Navbar />
        <div className="main-container">
          <div className="main-container-top">
            <SubMenu />
            <div className="container">
              <Outlet />
            </div>
          </div>
          <div className="main-container-bottom">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export { ProtectedRoutes };
